import './gamefooter.scss'
// import { Howler } from 'howler'
// import Draggable from 'react-draggable'
// import { useEffect } from 'react'
import {
  // MusicOffIcon,
  // MusicOnIcon,
  // ChartIcon,
  ProvableFairIcon,
  // SettingProfile,
  // StarMineIcon,
  // StateRefreshIcon,
  // VolumeMuteIcon,
  // VolumeUnMuteIcon
  // XCloseIcon
} from 'assets/icons/index'
// import { useLocation } from 'react-router-dom'
// import { DEFAULT_GAME_ID } from 'constants/index'
import { showToastToLogin } from 'helpers/common.helpers'
// import Chart from 'react-apexcharts'
import { useState, useEffect, useRef } from 'react'
import { ReactComponent as SettingsIcon } from './assets/svg/settings.svg'
import { ReactComponent as MusicIcon } from './assets/svg/music.svg'
import { ReactComponent as MusicMuteIcon } from './assets/svg/music-mute.svg'
import { ReactComponent as VolumeIcon } from './assets/svg/volume.svg'
import { ReactComponent as VolumeMuteIcon } from './assets/svg/volume-mute.svg'
// import { ReactComponent as FavoriteIcon } from './assets/svg/star.svg'
// import { ReactComponent as StatIcon } from './assets/svg/stat.svg'
import { setGameMusic, setGameSound } from 'redux-store/redux/slices/gameSettings.slice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

const GameFooter = (props) => {
  const {t} = useTranslation()
  const {
    // liveStats,
    // isKeyBindEnabled,
    // setIsHotkeysModal,
    handleFairnessModal,
    // setIsSetting,
    // isSetting,
    // resetStats,
    mobileBG,
    demoMode,
    // setMute,
    // mute,
    // setMusic,
    // music,
    gameSound,
    gameMusic
  } = props

  const dispatch = useDispatch()

  // const [state, setState] = useState({
  //   series: [{
  //     data: []
  //   }],
  //   options: {
  //     chart: {
  //       type: 'area'
  //       // foreColor: '#ffffff'
  //     },
  //     dataLabels: {
  //       enabled: false
  //     },
  //     tooltip: {
  //       enabled: true,
  //       custom: function ({ series, seriesIndex, dataPointIndex, w }) {
  //         const customElement = document.createElement('div')
  //         customElement.style.padding = '10px'
  //         customElement.innerHTML = series[seriesIndex][dataPointIndex]

  //         return customElement
  //       },
  //       x: {
  //         show: false
  //       }
  //     },
  //     stroke: {
  //       curve: 'smooth',
  //       width: 0
  //     },
  //     plotOptions: {
  //       line: {
  //         colors: {
  //           threshold: 0,
  //           colorAboveThreshold: '#08b535',
  //           colorBelowThreshold: '#f00a18'
  //         }
  //       }
  //     },
  //     grid: {
  //       show: false
  //     },
  //     fill: {
  //       // type: "gradient",
  //       gradient: {
  //         enabled: true,
  //         opacityFrom: 0.55,
  //         opacityTo: 0
  //       }
  //     },
  //     xaxis: {
  //       labels: {
  //         show: false
  //       },
  //       axisBorder: {
  //         show: false
  //       },
  //       axisTicks: {
  //         show: false
  //       },
  //       categories: []
  //     }
  //   }
  // })

  // useEffect(() => {
  //   setState(prevState => {
  //     const newData = [...prevState.series[0].data, (liveStats?.totalProfit)?.toFixed(2)]
  //     const newCategories = newData.map((_, index) => index)

  //     return {
  //       ...prevState,
  //       series: [{
  //         data: newData
  //       }],
  //       options: {
  //         ...prevState.options,
  //         xaxis: {
  //           // ...prevState.options.xaxis,
  //           labels: {
  //             show: false
  //           },
  //           axisBorder: {
  //             show: false
  //           },
  //           axisTicks: {
  //             show: false
  //           },
  //           categories: newCategories
  //         }
  //       }
  //     }
  //   })
  // }, [liveStats?.totalProfit])

  // const draggableRef = useRef(null)
  // const { search } = useLocation()

  // const [isLiveStats, setIsLiveStats] = useState(false)
  // const gameId = Number(new URLSearchParams(search).get('gameId'))

  // useEffect(() => {
  //   // Set the global Howler volume to 0 when the component mounts
  //   Howler.volume(mute ? 0 : 1)
  // }, [mute])

  // const resetHandler = () => {
  //   props?.resetStats()
  //   setState(prevState => ({
  //     ...prevState,
  //     series: [{
  //       data: []
  //     }],
  //     options: {
  //       ...prevState.options,
  //       xaxis: {
  //         ...prevState.options.xaxis,
  //         categories: []
  //       }
  //     }
  //   }))
  // }
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const settingsRef = useRef(null)
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        settingsRef.current &&
        !settingsRef.current.contains(event.target)
      ) {
        setIsSettingsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleOutsideClick)
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
    }
  }, [])

  return (
    <div className={`col-12 game-footer-col d-none d-lg-flex align-items-center justify-content-between ${mobileBG ? 'mobile-bg' : ''}`}>
      <div className='d-flex justify-content-center'>
        <ul className='list-inline mb-0 position-relative d-flex align-items-center'>
          {/* <li className='list-inline-item btn-group dropup'>
            <SettingProfile
              onClick={(e) => {
                e.stopPropagation()
                setIsSetting(!isSetting)
              }}

            />
            {isSetting && (
              <div className='dropdown-menu show border-0 soundSetting'>
                <div className='d-flex justify-content-between'>
                  <p className='m-0'>Sound</p>
                  {mute
                    ? (
                      <VolumeUnMuteIcon
                        onClick={() => {
                          setMute(!mute)
                        }}
                        className='dice-footer-icon'
                      />
                    )
                    : (
                      <VolumeMuteIcon
                        className='dice-footer-icon'
                        onClick={() => {
                          setMute(!mute)
                        }}
                      />
                    )}
                </div>
              </div>
            )}
          </li> */}
          <li
            ref={settingsRef}
            className='list-inline-item dropdown position-relative'
          >
            <button
              type='button'
              className='bg-transparent border-0'
              onClick={() => setIsSettingsOpen(prev => !prev)}
            >
              <SettingsIcon />
            </button>

            {isSettingsOpen && (
              <ul
                className='dropdown-menu dropdown-menu-dark show'
                style={{
                  position: 'absolute',
                  bottom: '100%',
                  left: 0,
                  marginBottom: '5px'
                }}
              >
                <li
                  className='px-3 mb-3'
                  onClick={() => {
                    dispatch(setGameSound(!gameSound))
                  }}
                >
                  {gameSound
                    ? (
                      <VolumeIcon
                        width={25}
                        height={25}
                        className='dice-footer-icon'
                      />
                      )
                    : (
                      <VolumeMuteIcon
                        width={25}
                        height={25}
                        className='dice-footer-icon'
                      />
                      )}

                  <span className='ms-2'>Audio</span>
                </li>

                <li
                  className='px-3 mb-2'
                  onClick={() => {
                    dispatch(setGameMusic(!gameMusic))
                  }}
                >
                  {gameMusic
                    ? (
                      <MusicIcon
                        width={25}
                        height={25}
                        className='dice-footer-icon'
                      />
                      )
                    : (
                      <MusicMuteIcon
                        width={25}
                        height={25}
                        className='dice-footer-icon'
                      />
                      )}

                  <span className='ms-2'>Music</span>
                </li>
              </ul>
            )}
          </li>
          {/* <li className='list-inline-item'>
            <FavoriteIcon />
          </li>
          <li className='list-inline-item'>
            <StatIcon />
          </li> */}

          {/* {liveStats && (
            <li className='list-inline-item live-stats-wrapper'>
              <ChartIcon
                className={`dice-footer-icon ${isLiveStats ? 'active' : ''}`}
                onClick={() => setIsLiveStats(!isLiveStats)}
              />

              {isLiveStats && (
                <div className='dropdown-menu border-0 show py-0'>
                  <Draggable
                    nodeRef={draggableRef}
                    handle='.handle'
                    cancel='.live-stats-action-btn'
                  >
                    <div
                      className='live-stats-dropdown-menu'
                      ref={draggableRef}
                    >
                      <div className='live-stats-content-head handle d-flex justify-content-between align-items-center'>
                        <h6 className='mb-0'>Live Stats</h6>
                        <div className='live-stats-action-btn'>
                          {resetStats && (
                            <StateRefreshIcon
                              className='live-stats-refresh-icon'
                              onClick={resetHandler}
                            />
                          )}
                          <XCloseIcon
                            className='live-stats-close-icon'
                            onClick={() => setIsLiveStats(false)}
                          />
                        </div>
                      </div>
                      <div className='live-stats-content-body'>

                        <div className='live-stats-cards d-flex justify-content-between'>
                          <div className=''>Profit/Loss</div>
                          <div
                            className={`${Number(liveStats?.totalProfit) >= 0
                              ? 'stats-result-text'
                              : 'stats-result-loss-text'
                              } fw-bold`}
                          >
                            {(liveStats?.totalProfit).toFixed(2) || '0'}
                          </div>
                        </div>

                        <div className='live-stats-cards d-flex justify-content-between'>
                          <div className=''>No. of wins</div>
                          <div className='stats-result-text fw-bold'>
                            {(liveStats?.totalWins).toFixed(2) || '0'}
                          </div>
                        </div>

                        <div className='live-stats-cards d-flex justify-content-between'>
                          <div className=''>Wagered</div>
                          <div className='stats-result-text fw-bold'>
                            {(liveStats?.totalWagered).toFixed(2) || '0'}
                          </div>
                        </div>

                        <div className='live-stats-cards d-flex justify-content-between'>
                          <div className=''>No. of losses</div>
                          <div className='stats-result-loss-text fw-bold'>
                            {(liveStats?.totalLost).toFixed(2) || '0'}
                          </div>
                        </div>
                      </div>
                      <Chart options={state.options} series={state.series} type='area' height={250} />
                    </div>
                  </Draggable>
                </div>
              )}
            </li>
          )} */}
          {/* {!(gameId === DEFAULT_GAME_ID.MULTI_CRASH || gameId === DEFAULT_GAME_ID.CHOPPER_CRASH || gameId === DEFAULT_GAME_ID.SOCCER_CRASH) &&
            (
              <li
                className={`list-inline-item ${isKeyBindEnabled ? 'active' : ''}`}
              >
                <Tooltip
                  placement='top'
                  trigger={['hover']}
                  overlayStyle={{ fontSize: '16px' }}
                  overlay={<span>Hotkeys</span>}
                >
                  <KeyboardIcon className={`dice-footer-icon ${isKeyBindEnabled ? 'active' : ''}`} onClick={() => setIsHotkeysModal(true)} />
                  <StarMineIcon
                  className={`dice-footer-icon ${isKeyBindEnabled ? 'active' : ''}`}
                  onClick={() => {
                    setIsHotkeysModal(true)
                  }}
                />
                </Tooltip>
              </li>
            )} */}
        </ul>
      </div>

      <div className='footer-logo'>
        <img src='../assets/images/common/canvas-gaming-logo.png' />
      </div>

      <div
        type='button'
        className='footer-fairness-label ms-2'
        onClick={demoMode ? showToastToLogin : handleFairnessModal}
      >
        {/* <ProvableFairIcon className='dice-footer-icon' /> */}
        {t('FAIRNESS')}
      </div>
    </div>
  )
}

export default GameFooter
